import React from 'react';

function FeaturesItem(props) {
    return (
        <>
            <div>

                <div className="flex justify-start items-center ">

                    <div className="bg-sky-400 rounded-full p-3">
                        {props.icon}
                    </div>

                    <div className="mx-5 mt-2">
                        <h4 className="text-md lg:text-1xl font-semibold text-gray-800">{props.title}</h4>
                        <p className=" text-sm lg:text-md text-gray-700 ">{props.message}</p>
                    </div>

                </div>

            </div>
        </>
    );
}

export default FeaturesItem;